import { render } from "./Educationweb.vue?vue&type=template&id=aada80a4&scoped=true"
import script from "./Educationweb.vue?vue&type=script&lang=js"
export * from "./Educationweb.vue?vue&type=script&lang=js"

import "./Educationweb.vue?vue&type=style&index=0&id=aada80a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aada80a4"]])

export default __exports__